module.exports = __webpack_public_path__ + "static/img/list4.56a9450.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/JoinUs/img/list4.png
// module id = vv5G
// module chunks = 1